import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  useToast,
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../api/AxiosInstance';
import FormularioEventoTurismo from './FormularioEventoTurismo';
import ModalEvidenciasTurismo from './ModalEvidenciasTurismo';

const TablaEventos: React.FC = () => {
  const toast = useToast();
  const cancelRef = useRef<any>(null);

  const { isOpen: isOpenVer, onOpen: onOpenVer, onClose: onCloseVer } = useDisclosure();
  const { isOpen: isOpenEditar, onOpen: onOpenEditar, onClose: onCloseEditar } = useDisclosure();
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();
  const { isOpen: isOpenEvidencias, onOpen: onOpenEvidencias, onClose: onCloseEvidencias } = useDisclosure();
  const { isOpen: isOpenCerrar, onOpen: onOpenCerrar, onClose: onCloseCerrar } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const [procesando, setProcesando] = useState(false);
  const [filtroEstatus, setFiltroEstatus] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('');
  const [busqueda, setBusqueda] = useState('');

  const fetchData = async () => {
    setCargando(true);
    try {
      const res = await axiosInstance.get('/turismo/eventos');
      setData(res.data || []);
    } catch {
      setData([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const datosFiltrados = data.filter((item) => {
    const matchEstatus = filtroEstatus ? item.estatus === filtroEstatus : true;
    const matchTipo = filtroTipo ? item.tipo === filtroTipo : true;
    const matchBusqueda = busqueda
      ? item.titulo?.toLowerCase().includes(busqueda.toLowerCase()) ||
        item.comunidad?.toLowerCase().includes(busqueda.toLowerCase())
      : true;
    return matchEstatus && matchTipo && matchBusqueda;
  });

  const handleVer = (item: any) => { setSelectedItem(item); onOpenVer(); };
  const handleEditar = (item: any) => { setSelectedItem(item); onOpenEditar(); };
  const handleEvidencias = (item: any) => { setSelectedItem(item); onOpenEvidencias(); };
  const handleGuardado = () => { onCloseNuevo(); onCloseEditar(); fetchData(); };
  const handleEvidenciasGuardadas = () => { onCloseEvidencias(); fetchData(); };
  const handleEliminar = async (item: any) => {
    const ok = window.confirm(`Eliminar el evento ${item.titulo}?`);
    if (!ok) return;
    try {
      await axiosInstance.delete(`/turismo/eventos/${item.id}`);
      fetchData();
    } catch {
      // noop
    }
  };

  const handleCerrarClick = (item: any) => { setSelectedItem(item); onOpenCerrar(); };

  const handleCerrarConfirmar = async () => {
    if (!selectedItem) return;
    setProcesando(true);
    try {
      await axiosInstance.post(`/turismo/eventos/${selectedItem.id}/cerrar`, {});
      toast({ title: 'Evento cerrado', status: 'success', duration: 3000 });
      onCloseCerrar();
      fetchData();
    } catch (error: any) {
      toast({ title: 'Error', description: error?.response?.data?.message || 'No se pudo cerrar.', status: 'error', duration: 4000 });
    } finally {
      setProcesando(false);
    }
  };

  const handlePdf = (id: number) => {
    const base = axiosInstance.defaults.baseURL || '';
    window.open(`${base}/turismo/eventos/${id}/pdf`, '_blank');
  };

  const formatFecha = (v: string) => (v ? new Date(v).toLocaleDateString('es-MX') : '-');

  return (
    <Box>
      <Flex mb={4} justify="space-between" align="center" flexWrap="wrap" gap={3}>
        <HStack spacing={3} flexWrap="wrap">
          <Input
            placeholder="Buscar por titulo o comunidad..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            size="sm"
            w={{ base: 'full', md: '260px' }}
          />
          <Select placeholder="Tipo" value={filtroTipo} onChange={(e) => setFiltroTipo(e.target.value)} size="sm" w="160px">
            {Array.from(new Set(data.map((d) => d.tipo).filter(Boolean))).map((tipo) => (
              <option key={tipo} value={tipo}>{tipo}</option>
            ))}
          </Select>
          <Select placeholder="Estatus" value={filtroEstatus} onChange={(e) => setFiltroEstatus(e.target.value)} size="sm" w="160px">
            <option value="activo">Activo</option>
            <option value="concluido">Concluido</option>
          </Select>
        </HStack>
        <Button size="sm" leftIcon={<AddIcon />} bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={onOpenNuevo}>
          Nuevo evento
        </Button>
      </Flex>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table variant="simple" size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Titulo</Th>
              <Th color="white" fontSize="xs">Tipo</Th>
              <Th color="white" fontSize="xs">Comunidad</Th>
              <Th color="white" fontSize="xs">Fecha</Th>
              <Th color="white" fontSize="xs">Responsable</Th>
              <Th color="white" fontSize="xs">Estatus</Th>
              <Th color="white" fontSize="xs">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cargando ? (
              <Tr><Td colSpan={7} textAlign="center" py={8}><Text color="gray.500">Cargando...</Text></Td></Tr>
            ) : datosFiltrados.length === 0 ? (
              <Tr><Td colSpan={7} textAlign="center" py={8}><Text color="gray.400">Sin registros</Text></Td></Tr>
            ) : (
              datosFiltrados.map((item, idx) => (
                <Tr key={item.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: '#f7efe8' }}>
                  <Td maxW="220px"><Text noOfLines={1} title={item.titulo}>{item.titulo}</Text></Td>
                  <Td>{item.tipo}</Td>
                  <Td>{item.comunidad || '-'}</Td>
                  <Td>{formatFecha(item.fecha)}</Td>
                  <Td>{item.responsable || '-'}</Td>
                  <Td><Badge colorScheme={item.estatus === 'concluido' ? 'blue' : 'green'}>{item.estatus}</Badge></Td>
                  <Td>
                    <HStack spacing={1} flexWrap="wrap">
                      <Button size="xs" colorScheme="blue" variant="outline" onClick={() => handleVer(item)}>Ver</Button>
                      <Button size="xs" colorScheme="orange" variant="outline" onClick={() => handleEditar(item)}>Editar</Button>
                      <Button size="xs" colorScheme="teal" variant="outline" onClick={() => handleEvidencias(item)}>Evidencias</Button>
                      {item.estatus === 'activo' && (
                        <Button size="xs" colorScheme="blue" variant="solid" onClick={() => handleCerrarClick(item)}>Cerrar</Button>
                      )}
                      <Button size="xs" colorScheme="purple" variant="outline" onClick={() => handlePdf(item.id)}>PDF</Button>
                      <Button size="xs" colorScheme="red" variant="outline" onClick={() => handleEliminar(item)}>Eliminar</Button>
                    </HStack>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpenVer} onClose={onCloseVer} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Detalle del evento</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioEventoTurismo modo="view" data={selectedItem} />}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" bg="gray.50">
            <Button onClick={onCloseVer}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenEditar} onClose={onCloseEditar} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Editar evento</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioEventoTurismo modo="edit" data={selectedItem} onGuardado={handleGuardado} onCancelar={onCloseEditar} />}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenNuevo} onClose={onCloseNuevo} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Nuevo evento</ModalHeader>
          <ModalBody py={5} bg="white">
            <FormularioEventoTurismo modo="new" onGuardado={handleGuardado} onCancelar={onCloseNuevo} />
          </ModalBody>
        </ModalContent>
      </Modal>

      {selectedItem && (
        <ModalEvidenciasTurismo
          isOpen={isOpenEvidencias}
          onClose={onCloseEvidencias}
          evento={selectedItem}
          onGuardado={handleEvidenciasGuardadas}
        />
      )}

      <AlertDialog isOpen={isOpenCerrar} leastDestructiveRef={cancelRef} onClose={onCloseCerrar}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold" color="#5b182b">Cerrar evento</AlertDialogHeader>
            <AlertDialogBody>
              Confirmas el cierre del evento <strong>{selectedItem?.titulo}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseCerrar} isDisabled={procesando}>Cancelar</Button>
              <Button colorScheme="blue" onClick={handleCerrarConfirmar} ml={3} isLoading={procesando} loadingText="Cerrando...">
                Confirmar cierre
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default TablaEventos;


